<template>
  <v-dialog v-model="dialog" width="600px">
    <v-card>
      <v-card-title class="mx-3">
        {{ $t("SubAccountConfig.subAccountPercentSettings.title") }}
        <v-spacer></v-spacer>
        <v-tooltip left>
          <template v-slot:activator="{ on, attrs }">
            <v-icon v-bind="attrs" v-on="on" @click="dialog = false">
              fa-times
            </v-icon>
          </template>
          <span>{{ $t("$vuetify.close") }}</span>
        </v-tooltip>
      </v-card-title>

      <v-data-table
        :headers="percentSettingHeaders"
        :items="subAccoutSettings"
        :loading="loading"
        multi-sort
        disable-pagination
        hide-default-footer
        class="elevation-0 px-6"
        height="400px"
        fixed-header
      >
        <template v-slot:item.sub_account_id="{ item }">
          <span v-if="isView">
            {{
              sub_accounts.find((s)=>s.id == item.sub_account_id) ?
                sub_accounts.find((s)=>s.id == item.sub_account_id).name :
                ""
            }}
          </span>
          <v-select
            v-else
            single-line
            dense
            hide-details
            v-model="item.sub_account_id"
            :items="subAccounts(item.code)"
            item-value="id"
            item-text="text"
            style="max-width: 220px; margin-left: auto"
            clearable
          />
        </template>
      </v-data-table>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" outlined @click="dialog = false">
          {{ $t("$vuetify.close") }}
        </v-btn>
        <v-btn color="accent" 
          @click="
            dialog = false;
            confirm()
          "
        >
          {{ $t("CRUD.confirm") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import i18n from "@/i18n";
import { mapState } from "vuex";
import SubAccounts from "@/api/sub_accounts";

export default {
  name: "SubAccountConfigsDialog",

  props: {
    value: Boolean,
    subAccoutSettings: Array,
    isView: Boolean,
  },

  computed: {
    percentSettingHeaders() {
      return [
        {
          text: i18n.t("Shop.Fields.sub_account_type"),
          align: "center",
          sortable: true,
          value: "name",
        },
        {
          text: i18n.t("Shop.Fields.sub_account"),
          align: "end",
          sortable: true,
          value: "sub_account_id",
        },
      ];
    },
    // 使用对象展开运算符将此对象混入到外部对象中
    ...mapState(["loading"]),
  },

  data: () => ({
    dialog: false,
    sub_accounts: [], //第一次获取商品列表的时间
  }),

  methods: {
    getSubAccounts() {
      SubAccounts.fetch({
        bank_code: "ABC",
        delete_flgs: [0],
      }).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.sub_accounts = response.data.sub_accounts;
          }
        }.bind(this)
      );
    },
    subAccounts(sub_account_type_code) {
      var sub_accounts = [];
      this.sub_accounts
        .filter(
          (sub_account) => sub_account.sub_account_type == sub_account_type_code
        )
        .forEach((sub_account) => {
          sub_account.text =
            sub_account.account_name + " / " + sub_account.account_number;
          sub_accounts.push(sub_account);
        });
        
      return sub_accounts;
    },
    confirm() {
      var sub_account_settings = this.subAccoutSettings.map((setting)=>{
        if (setting.sub_account_id &&
            !this.sub_accounts.find((a)=>a.id==setting.sub_account_id)
          ) {
          setting.sub_account_id="";
        }
        return setting;
      })
      this.$emit('confirm', sub_account_settings)
    },
  },

  watch: {
    value: {
      immediate: true, //初始赋值也调用
      handler() {
          this.getSubAccounts();
        if (this.value) {
          this.dialog = this.value;
        }
      },
    },
    dialog: {
      handler() {
        if (!this.dialog) {
          this.sub_accounts = [];
        }
        this.$emit("input", this.dialog);
      },
    },
  },
};
</script>